import FormattedMessage from 'I18n/components/FormattedMessage';
import { UserTicketStatusOption } from '../data/types';
import { useCloseTicket } from '../data/useCloseTicket';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { XCircleIcon } from 'foundations-assets/icons/components/XCircleIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import I18n from 'I18n';
import { usePortalData } from '../data/usePortalData';
import { useIsPreview } from '../hooks/useIsPreview';
import { usageTracker } from '../utils/usageTracker';
import { useConfirmModal } from '../hooks/useConfirmModal';
import { PortalConfirmModal } from './atoms/PortalConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CloseTicket = ({
  ticket,
  ticketId
}) => {
  var _portalData$settings;
  const isPreview = useIsPreview();
  const {
    data: portalData
  } = usePortalData();
  const allowTicketClosure = portalData === null || portalData === void 0 || (_portalData$settings = portalData.settings) === null || _portalData$settings === void 0 ? void 0 : _portalData$settings.allowTicketClosure;
  const {
    closeTicket,
    isTicketClosing
  } = useCloseTicket();
  const {
    isOpen,
    openConfirmModal,
    confirmModalProps
  } = useConfirmModal({
    onConfirm: () => {
      if (isPreview) {
        return;
      }
      usageTracker.track('Customer Portal App', 'Tickets Manipulated', {
        action: 'ticket-closed',
        screen: 'ticket-details'
      });
      void closeTicket(ticketId);
    }
  });

  // Do not display button if portal settings disallow closing tickets (also wont render while loading or if error)
  if (!allowTicketClosure) {
    return null;
  }

  // Do not display button if ticket is closed
  if (!ticket || ticket.status !== UserTicketStatusOption.OPEN) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isOpen && /*#__PURE__*/_jsx(PortalConfirmModal, Object.assign({
      message: /*#__PURE__*/_jsx(Text, {
        color: "text-core-default",
        typography: "heading-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.ticketInfoPanel.confirmClose.title"
        })
      }),
      description: /*#__PURE__*/_jsx(Text, {
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.ticketInfoPanel.confirmClose.content"
        })
      }),
      confirmLabel: I18n.text('customer-portal-app.ticketInfoPanel.confirmClose.confirmText'),
      rejectLabel: I18n.text('customer-portal-app.ticketInfoPanel.confirmClose.cancelText'),
      confirmButtonProps: {
        'data-test-id': 'close-ticket-confirm-button'
      }
    }, confirmModalProps, {
      size: "auto"
    })), /*#__PURE__*/_jsx(Tooltip, {
      title: isTicketClosing ? I18n.text('customer-portal-app.ticketInfoPanel.closing') : undefined,
      children: /*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "close-ticket-button",
        use: "primary",
        onClick: openConfirmModal,
        disabled: isTicketClosing,
        loading: isTicketClosing,
        resultIcon: XCircleIcon,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'customer-portal-app.ticketInfoPanel.close'
        })
      })
    })]
  });
};